// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// Custom Event polyfill
import 'custom-event-polyfill/polyfill';

// Import Axios
import 'axios/dist/axios.min';

// Import Qs
import 'qs/dist/qs';

// magnific popup
import 'magnific-popup/dist/jquery.magnific-popup.min';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import templateArmedForcesPartnerships from './routes/mou';
import newsEvents from './routes/news';
import contactUs from './routes/contact';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Armed Forces Partnerships Page.
  templateArmedForcesPartnerships,
  // News and Events pagen
  newsEvents,
  // Contact us page
  contactUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js